export default __webpack_public_path__ + "media/images/features/yado/world_tourlist-3aae8336c0bb8314688dd8d69f3372ec.png";